import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum AddictionMainAssets {

    BACKGROUND = "AddictionMainBACKGROUND",

    MENTAL = "AddictionMainMENTAL",
    PHYSICAL = "AddictionMainPHYSICAL",
    CRAVINGS_AND_WITHDRAWAL = "AddictionMainCRAVINGS_AND_WITHDRAWAL",
    NICOTINE_AND_ADDICTION = "AddictionMaiNNICOTINE_AND_ADDICTION",

    INTRO = "AddictionMainINTRO",
    DONE = "AddictionMainDONE",
    POST_EXPERIMENT = "AddictionMainPOST_EXPERIMENT",

}

export function loadMainAssets(game: Phaser.Game) {
    game.load.image(AddictionMainAssets.BACKGROUND, CCUtils.asset("addiction/main/background.png"))
    game.load.image(AddictionMainAssets.CRAVINGS_AND_WITHDRAWAL, CCUtils.asset("addiction/main/cravings-and-withdrawal.png"))
    game.load.image(AddictionMainAssets.PHYSICAL, CCUtils.asset("addiction/main/physical.png"))
    game.load.image(AddictionMainAssets.NICOTINE_AND_ADDICTION, CCUtils.asset("addiction/main/nicotine-and-addiction.png"))

    game.load.spritesheet(AddictionMainAssets.MENTAL, CCUtils.asset("addiction/main/mental-wagging.png"), 369, 361)

    game.load.audio(AddictionMainAssets.INTRO, CCUtils.asset("addiction/main/audio/addiction-101-intro.mp3"))
    game.load.audio(AddictionMainAssets.DONE, CCUtils.asset("addiction/main/audio/addiction-101-done.mp3"))
    game.load.audio(AddictionMainAssets.POST_EXPERIMENT, CCUtils.asset("addiction/main/audio/addiction-101-post-experiment.mp3"))
}
